import React from 'react';

import {DataFrame} from 'data-frames/DataFrameTypes';
import {VisualizationType} from 'insights/analytics-visualizations/AnalyticsVisualizationTypes';
import makeVisualizationConfig from 'insights/universal-blocks/makeVisualizationConfig';

import ModelingDashboardBlock, {SharedModelingBlockProps} from './ModelingDashboardBlock';

export const MODEL_METRICS_TABLE_BLOCK_TITLE = 'Model metrics';
const MODEL_METRICS_TABLE_BLOCK_DESCRIPTION = `R-squared is the percentage of variation that helps you determine how well the model's prediction approximates the actual data. The closer the R-squared value is to 1, the better the fit.`;

/** @package */
export const VISUALIZATION_TYPE = VisualizationType.TABLE;
/** @package */
export const BASE_VISUALIZATION_PARAMETERS = {
  displayColumnsJson: null,
};

interface ModelMetricsTableBlockProps extends SharedModelingBlockProps {
  dataFrame: DataFrame;
}

export default function ModelMetricsTableBlock({
  dataFrame,
  ...sharedModelingBlockProps
}: ModelMetricsTableBlockProps): JSX.Element {
  const visualizationConfig = makeVisualizationConfig(VISUALIZATION_TYPE, BASE_VISUALIZATION_PARAMETERS);

  return (
    <ModelingDashboardBlock
      {...sharedModelingBlockProps}
      blockTitle={MODEL_METRICS_TABLE_BLOCK_TITLE}
      blockDescription={MODEL_METRICS_TABLE_BLOCK_DESCRIPTION}
      inputDataFrame={dataFrame}
      visualizationConfig={visualizationConfig}
    />
  );
}
